import I18n from 'I18n';
import { SET_TABLE_AS_MODULE_SCHEMA_SUCCEEDED } from 'structured-content-lib/redux/actions/ActionTypes';

/**
 * Hacky middleware that sets the label and inline_help_text of inline editable built-in SCP columns
 * Currently, the SCP can't store translated labels and descriptions on built in columns
 * In the interim while we work on a better solution, this middleware will listen to
 * the `SET_TABLE_AS_MODULE_SCHEMA_SUCCEEDED` action that's fired by structured-content-lib when the requests for the table
 * as a module schema come back. Before it reaches its reducer to be stored, we'll mutate the field's we care about to
 * include the translated label and inline_help_text for the property
 */
export default function scpPropertyLabelAndDescriptionMiddleware() {
  return __store => next => action => {
    if (action.type === SET_TABLE_AS_MODULE_SCHEMA_SUCCEEDED) {
      const {
        payload
      } = action;
      const {
        fields
      } = payload;
      if (!fields) {
        return next(action);
      }
      fields.forEach(field => {
        if (field.name === 'hs_name') {
          field.inline_help_text = I18n.text('caseStudyEditor.emptyTitlePlaceholder');
          field.label = undefined;
        }
      });
    }
    return next(action);
  };
}